<template>
  <div class="week">
    <div
      v-for="day in $t(`${namespace}.daysOfWeekShortened`)"
      :key="day.value"
      class="week__label"
    >
      <div
        class="week__content"
        :class="[
          { 'week__content--start': timePolicyType === 'workingDays' && day.value === 1 },
          { 'week__content--end': timePolicyType === 'workingDays' && day.value === 5 },
          { 'week__content--active': Boolean(days.filter(item => item === day.value).length) }
        ]"
      >
        <input
          v-model="daysOfWeek"
          type="checkbox"
          :value="day.value"
          :ref="`day-${day.value}`"
          :disabled="timePolicyType === 'workingDays'"
          @change="handleSetDaysOfWeek"
        >
        <span>{{ day.name }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DaysOfWeek',
  props: {
    timePolicyType: {
      type: String,
      required: true
    },
    days: {
      type: Array,
      required: true
    },
    reset: {
      type: Boolean
    }
  },
  data () {
    return {
      namespace: 'Views.UsagePolicyPage.timeRangeComboBox',
      daysOfWeek: []
    }
  },
  methods: {
    handleSetDaysOfWeek () {
      this.$emit('setDaysOfWeek', this.daysOfWeek)
    }
  },
  watch: {
    reset () {
      this.daysOfWeek = []
    }
  }
}
</script>

<style lang="scss" scoped>
.week {
  max-width: 585px;
  margin: 0 auto 24px;
  text-align: center;

  &:before,
  &:after {
    clear: both;
    content: '';
    display: block;
  }

  .week__label {
    cursor: pointer;
    float: left;
    width: 14.285714285714286%;
    height: 64px;

    .week__content {
      border: solid 1px $gray-2;
      background-color: $white;
      margin: 0 2px;
      position: relative;
      transition: border .26s;

      input {
        cursor: pointer;
        display: block;
        height: 64px;
        left: 0;
        opacity: 0;
        position: absolute;
        width: 100%;

        &[disabled] {
          cursor: not-allowed;
        }
      }

      span {
        display: block;
        font-family: 'Montserrat', sans-serif;
        font-size: 18px;
        font-weight: 800;
        font-style: normal;
        font-stretch: normal;
        line-height: 64px;
        letter-spacing: normal;
        text-align: center;
        color: $gray-4;
        transition: color .26s;
      }

      &.week__content--active {
        border-color: $accent;

        span {
          color: $accent;
        }
      }

      &.week__content--start {
        position: relative;

        &:before,
        &:after {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          left: 100%;
        }

        &:before {
          content: '';
          border-bottom: 4px solid transparent;
          border-left: 4px solid $accent;
          border-right: 4px solid transparent;
          border-top: 4px solid transparent;
          margin-left: 1px;
          z-index: 0;
        }

        &:after {
          content: '';
          border-bottom: 4px solid transparent;
          border-left: 4px solid $white;
          border-right: 4px solid transparent;
          border-top: 4px solid transparent;
          z-index: 1;
        }
      }

      &.week__content--end {
        position: relative;

        &:before,
        &:after {
          position: absolute;
          right: 100%;
          top: 50%;
          transform: translateY(-50%);
        }

        &:before {
          content: '';
          border-bottom: 4px solid transparent;
          border-left: 4px solid transparent;
          border-right: 4px solid $accent;
          border-top: 4px solid transparent;
          margin-right: 1px;
          z-index: 0;
        }

        &:after {
          content: '';
          border-bottom: 4px solid transparent;
          border-left: 4px solid transparent;
          border-right: 4px solid $white;
          border-top: 4px solid transparent;
          z-index: 1;
        }
      }
    }
  }
}
</style>
